import { useLocale } from "next-intl";

export const useCurrentLocale = (): string => {
  const locale = useLocale();
  return locale.split("-")[0] || "it";
};
